import { useEffect } from 'react';
import { Uuid } from 'src/apis/api-utilities';
import { PermissionGroupResponse } from 'src/apis/authorization-service/types';
import { PermissionGroupsRequest } from 'src/apis/authorization-service/use-permission-groups';
import { Successful, useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type HookProps = {
  permissionGroups?: PermissionGroupsRequest;
  permissionGroupId: Uuid;
};

type ExecuteProps = {
  permissionGroups: Successful<PermissionGroupsRequest>;
  permissionGroupId: Uuid;
};

export function usePermissionGroup({
  permissionGroups,
  permissionGroupId,
}: HookProps) {
  const request = useAxios(
    (axios, signal, { permissionGroups, permissionGroupId }: ExecuteProps) => {
      const url = urlTemplate
        .parse(permissionGroups.response.data._links.instance.href)
        .expand({ permissionGroupId });

      return axios.request<PermissionGroupResponse>({
        signal,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!permissionGroups?.response) return;
    request.execute({ permissionGroups, permissionGroupId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionGroups?.response, permissionGroupId]);

  if (!permissionGroups) return;

  return request;
}

export type PermissionGroupRequest = ReturnType<typeof usePermissionGroup>;
